import { ItemList } from '../orm'

const DEFAULT_NUM_ITEMS_PER_PAGE_FOR_GALLERY_PHOTOS = 1000

class PhotographList extends ItemList {
  getEntityKey() {
    return "photographer/photograph"
  }

  fetchGalleryPhotographs(gallery_id) {
    return async (dispatch, getState) => {
      dispatch(this.updatePaginationNumItemsPerPage(DEFAULT_NUM_ITEMS_PER_PAGE_FOR_GALLERY_PHOTOS))
      dispatch(this.updateListFilter({ gallery_id }))
      dispatch(this.fetchListIfNeeded())
    }
  }
  
  getGalleryPhotographs() {
    return this.getVisibleObjects()
  }

}

export const photographList = new PhotographList("photograph_default")
